import { render } from "./Trail.vue?vue&type=template&id=5cb68456&scoped=true"
import script from "./Trail.vue?vue&type=script&lang=js"
export * from "./Trail.vue?vue&type=script&lang=js"

import "./Trail.vue?vue&type=style&index=0&id=5cb68456&lang=scss&scoped=true"

import exportComponent from "/opt/web_acelerometrica_publica/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb68456"]])

export default __exports__